import React, { useEffect, useState } from "react";
import "./index.scss";
import { useSelector, useStore } from "react-redux";
import { useLanguage } from "../../../Translate/LanguageContext";
import { Formik, Form, ErrorMessage } from "formik";
import { dachboardSignIn } from "../services/index";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../theme/themeContext";
import CustomInput from "../../../components/CustomInput";
import * as Yup from "yup";
import backgroundLightLTR from "../../../assets/auth-light-ltr.png";
import backgroundLightRTL from "../../../assets/auth-light-rtl.png";
import backgroundDarkLTR from "../../../assets/auth-dark-ltr.png";
import backgroundDarkRTL from "../../../assets/auth-dark-rtl.png";
import Icon from "../../../components/CustomIcon/Icon";
// import ArrayOfLanguages from "../../../Translate/Languages/Language";
import Footer from "../Cardfooter/index";

function Login() {
  const { themeMode } = useTheme();
  const [loginMessage, setLoginMessage] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const store = useStore();
  const { translate } = useLanguage();
  const navigate = useNavigate();

  function updateLoginStatus() {
    store.dispatch({
      type: "dashboard/updateLoginStatus",
      payload: {
        isLoggedin: true,
      },
    });
  }

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required(() => translate("Please enter your email")),
    password: Yup.string().required(() =>
      translate("Please enter your password")
    ),
  });

  function goMonitor() {
    navigate(installStatus ? "/monitor" : "/installer");
  }

  const installStatus = useSelector(
    (state) => state?.entities?.dashboard?.completedInstallation
  );

  const language = useSelector(
    (state) => state?.entities?.settings?.language || "en"
  );

  function toggleDropdown() {
    setShowDropdown(!showDropdown);
  }

  const handleLanguageDropdownClick = (event) => {
    if (showDropdown && !event.target.closest(".LanguageBtn")) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleLanguageDropdownClick);

    return () => {
      document.removeEventListener("click", handleLanguageDropdownClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDropdown]);

  function changeLanguage(lang) {
    store.dispatch({
      type: "settings/changeLanguage",
      payload: {
        language: lang,
      },
    });

    setShowDropdown(false);
  }

  const languages = [
    { LangName: "English", LangSymbole: "EN", lang: "en" },
    // { LangName: "Français", LangSymbole: "FR", lang: "fr" },
    // { LangName: "Deutsch", LangSymbole: "AL", lang: "al" },
    { LangName: "العربية", LangSymbole: "ع", lang: "ar" },
    // { LangName: "Italiano", LangSymbole: "IT", lang: "it" },
  ];

  return (
    <div
      className="login-screen"
      style={{
        backgroundImage: `url(${
          themeMode?.toLowerCase() === "dark"
            ? language?.toLowerCase() === "ar"
              ? backgroundDarkRTL
              : backgroundDarkLTR
            : language?.toLowerCase() === "ar"
            ? backgroundLightRTL
            : backgroundLightLTR
        })`,
      }}
    >
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={LoginSchema}
        onSubmit={(values) => {
          dachboardSignIn(values.email, values.password)
            .then((response) => {
              if (response?.success) {
                updateLoginStatus();
                goMonitor();
              } else {
                setLoginMessage(
                  response?.message?.message ?? response?.message
                );
              }
            })
            .catch((error) => {
              setLoginMessage(error?.message);
            });
        }}
      >
        {({ touched, errors, values, handleChange }) => (
          <Form>
            <div
              className={`form-card ${
                language?.toLowerCase() === "ar" && "rtl-card"
              }`}
            >
              <div
                className="card-header"
                style={{
                  flexDirection:
                    language?.toLowerCase() === "ar" && "row-reverse",
                }}
              >
                <div className="void"></div>
                <div className="login-logo">
                  <Icon className="logo" icon="BlackLogo" />
                </div>
                <div
                  className="LanguageBtn"
                  style={{
                    flexDirection:
                      language?.toLowerCase() === "ar" && "row-reverse",
                  }}
                >
                  <div className="LanguageLabel" onClick={toggleDropdown}>
                    {language === "en" ? "EN" : "ع"}
                  </div>
                  <div className="LanguageIcon" onClick={toggleDropdown}>
                    <Icon className="languageGlobe" icon="language" size={30} />
                  </div>
                  {showDropdown && (
                    <div className="language-dropdown">
                      {languages?.map((lang, index) => {
                        return (
                          <div
                            key={index}
                            className={`lang-item ${
                              language === lang?.lang && "active-lang"
                            }`}
                            onClick={() =>
                              changeLanguage(lang?.lang?.toLowerCase())
                            }
                          >
                            <div className="lang-name">{lang?.LangName}</div>
                            <div className="lang-symbole">
                              {lang?.LangSymbole}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div className="card-content">
                <CustomInput
                  label={translate("Email")}
                  required
                  value={values.email}
                  language={language}
                  onChange={handleChange("email")}
                >
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="errorMessage"
                  />
                </CustomInput>
                <CustomInput
                  required
                  label={translate("password")}
                  value={values.password}
                  type="password"
                  onChange={handleChange("password")}
                  language={language}
                >
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="errorMessage"
                  />
                </CustomInput>
                <div className="serverErrorMessage">{loginMessage}</div>
              </div>
              <button
                className={Formik.isValid ? "submitButton" : "submitButton"}
                disabled={Formik.isValid}
                data-testid="ConnectButton"
                type="submit"
              >
                <span className="ConnectButton-text">
                  {translate("Connect")}
                </span>
              </button>
              <Footer />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default Login;
